const COUNTRY_NAME_CODE_MAP = {
    'germany': 'de',
    'sweden': 'se',
    'switzerland': 'ch',
    'canada': 'ca',
    'iceland': 'is',
    'poland': 'pl',
    'united-kingdom': 'gb',
    'denmark': 'dk',
    'norway': 'no',
    'finland': 'fi',
    'luxembourg': 'lu',
    'united-states': 'us',
    'france': 'fr',
    'china': 'cn',
    'japan': 'jp',
}

const CountryNameToCodeMapper = (countryName) => {
    return COUNTRY_NAME_CODE_MAP[countryName.toLowerCase()]

}

export default CountryNameToCodeMapper
